import {Colors} from 'appearance'
import Button from 'components/Control/Button'
import {useGetInvoiceOverviewMutation} from 'store/Store'
import PDFViewerModal from 'components/Modal/PDFViewerModal'
import {useState} from 'react'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'

const isMobileDevice = () => typeof navigator !== 'undefined' && /iPad|iPhone|iPod|Android/i.test(navigator.userAgent)

const readBlobAsDataUrl = (blob) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = () => reject(new Error('Failed to read PDF blob'))
        reader.readAsDataURL(blob)
    })

const createPdfUrl = async (pdf) => {
    if (!pdf?.data) {
        return null
    }

    let fileBytes

    try {
        fileBytes = pdf.data instanceof Uint8Array ? pdf.data : new Uint8Array(pdf.data)
    } catch (err) {
        console.error('Failed to parse PDF response', err)
        throw err
    }

    const blob = new Blob([fileBytes], {type: 'application/pdf'})
    const shouldUseDataUrl = isMobileDevice()

    if (shouldUseDataUrl) {
        return await readBlobAsDataUrl(blob)
    }

    if (typeof window === 'undefined' || !window.URL?.createObjectURL) {
        return await readBlobAsDataUrl(blob)
    }

    return window.URL.createObjectURL(blob)
}

const invoice = [
    {
        Component: ({handleSubmit}) => {
            const {t} = useTranslation()
            const [doOverview] = useGetInvoiceOverviewMutation()
            const [pdfUrl, setPdfUrl] = useState(null)
            const [isModalOpen, setIsModalOpen] = useState(false)

            const onSubmit = (data) => {
                toast.promise(
                    doOverview(data)
                        .unwrap()
                        .then(async (pdf) => {
                            if (!pdf) {
                                return
                            }

                            const url = await createPdfUrl(pdf)
                            if (!url) {
                                throw new Error('Failed to prepare PDF preview')
                            }

                            setPdfUrl(url)
                            setIsModalOpen(true)
                        })
                        .catch((err) => {
                            console.log('err', err)
                            throw err
                        }),
                    {
                        loading: t('loading'),
                        success: () => t('invoices.createPdfSuccess'),
                        error: () => t('invoices.createPdfError'),
                    }
                )
            }

            const handleCloseModal = () => {
                setIsModalOpen(false)
                if (pdfUrl) {
                    if (typeof window !== 'undefined' && window.URL?.revokeObjectURL && pdfUrl.startsWith('blob:')) {
                        window.URL.revokeObjectURL(pdfUrl)
                    }
                    setPdfUrl(null)
                }
            }

            return (
                <>
                    <Button
                        onClick={handleSubmit(onSubmit)}
                        variant="contained"
                        style={{backgroundColor: Colors.primary}}>
                        {t('fromDialogActions.overview')}
                    </Button>
                    <PDFViewerModal
                        open={isModalOpen}
                        onClose={handleCloseModal}
                        pdfUrl={pdfUrl}
                        title={t('fromDialogActions.overview')}
                    />
                </>
            )
        },
    },
]

const formDialogActions = {invoice}
export default formDialogActions
